import reducer from "./reducers";

import * as referenceActions from "./actions";

export { referenceActions };

export default reducer;
